module.exports = __webpack_public_path__ + "static/media/tokenlist.1115f4a9.svg";